import type {
  IAudienceTemplate,
  IAudienceTemplatePayload,
} from '@/Interfaces/AudienceTemplates/AudienceTemplate.interface';
import { createAsyncThunk } from '@reduxjs/toolkit';
import * as Sentry from '@sentry/react';
import {
  createAudienceTemplate as createAudienceTemplateApi,
  deleteAudienceTemplate as deleteAudienceTemplateApi,
  fetchAudienceTemplates,
  updateAudienceTemplate as updateAudienceTemplateApi,
} from '../api/audienceTemplates.api';

enum Action {
  GetAudienceTemplates = 'audienceTemplates/getAll',
  CreateAudienceTemplate = 'audienceTemplates/create',
  UpdateAudienceTemplate = 'audienceTemplates/update',
  DeleteAudienceTemplate = 'audienceTemplates/delete',
}

export const getAudienceTemplates = createAsyncThunk<IAudienceTemplate[]>(Action.GetAudienceTemplates, async () => {
  try {
    return await fetchAudienceTemplates();
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
});

export const createAudienceTemplate = createAsyncThunk<IAudienceTemplate, IAudienceTemplatePayload>(
  Action.CreateAudienceTemplate,
  async payload => {
    try {
      return await createAudienceTemplateApi(payload);
    } catch (error) {
      Sentry.captureException(error);
      throw error;
    }
  },
);

export const updateAudienceTemplate = createAsyncThunk<
  IAudienceTemplate,
  { id: number; payload: IAudienceTemplatePayload }
>(Action.UpdateAudienceTemplate, async ({ id, payload }) => {
  try {
    return await updateAudienceTemplateApi(id, payload);
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
});

export const deleteAudienceTemplate = createAsyncThunk<number, number>(Action.DeleteAudienceTemplate, async id => {
  try {
    await deleteAudienceTemplateApi(id);
    return id;
  } catch (error) {
    Sentry.captureException(error);
    throw error;
  }
});
